import { DashboardShell } from '../components/DashboardShell';

/**
 * Phase 10 customizable dashboard. Tab-based shell with a role-aware KPI
 * strip on top and a draggable widget grid inside each tab. Layout state
 * lives in `localStorage` per-user per-tab — see use-dashboard-layout.ts.
 */
export function DashboardPage() {
  return <DashboardShell />;
}
